import React from "react";

const NotFound = () => {
  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f4f6f8",
      }}
    >
      <div
        style={{
          maxWidth: 500,
          width: "100%",
          padding: "40px 30px",
          backgroundColor: "#ffffff",
          borderRadius: 12,
          textAlign: "center",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
        }}
      >
        <h1
          style={{
            fontSize: 72,
            margin: 0,
            fontWeight: 700,
            color: "#d63031",
          }}
        >
          404
        </h1>

        <h3
          style={{
            marginTop: 12,
            fontSize: 20,
            fontWeight: 600,
            color: "#2d3436",
          }}
        >
          Page Not Found
        </h3>

        <p
          style={{
            marginTop: 10,
            fontSize: 14,
            color: "#636e72",
            lineHeight: 1.6,
          }}
        >
          The page you are trying to access does not exist or may have been
          removed. Please check the URL and try again.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
